import { WebGLContext } from './WebGLContext';
import { WebGLUtils } from './WebGLUtils';

const VERTEX_SHADER = `
  attribute vec2 a_position;
  uniform vec2 u_resolution;
  uniform vec2 u_translate;
  uniform float u_scale;

  void main() {
    vec2 pos = (a_position * u_scale) + u_translate;
    vec2 clipSpace = (pos / u_resolution) * 2.0 - 1.0;
    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);
  }
`;

const FRAGMENT_SHADER = `
  precision mediump float;
  uniform vec4 u_color;
  void main() {
    gl_FragColor = u_color;
  }
`;

export class LineRenderer {
  private program: WebGLProgram;
  private buffer: WebGLBuffer;
  private lineData = new Float32Array(4);

  constructor(private context: WebGLContext) {
    const gl = context.gl;
    this.program = WebGLUtils.createProgram(gl, VERTEX_SHADER, FRAGMENT_SHADER);
    this.buffer = gl.createBuffer()!;
  }

  renderLine(p1: {x: number, y: number}, p2: {x: number, y: number}, color: number[], opacity: number, camera: {x: number, y: number, scale: number}, zoomLevel: number) {
    const gl = this.context.gl;
    this.context.useProgram(this.program);
    
    WebGLUtils.updateCommonUniforms(gl, this.program, this.context.width, this.context.height, camera, zoomLevel);

    const posLocation = gl.getAttribLocation(this.program, 'a_position');
    const colorLocation = gl.getUniformLocation(this.program, 'u_color');

    gl.uniform4f(colorLocation, color[0]/255, color[1]/255, color[2]/255, opacity);

    this.lineData[0] = p1.x;
    this.lineData[1] = p1.y;
    this.lineData[2] = p2.x;
    this.lineData[3] = p2.y;

    gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
    gl.bufferData(gl.ARRAY_BUFFER, this.lineData, gl.DYNAMIC_DRAW);
    gl.enableVertexAttribArray(posLocation);
    gl.vertexAttribPointer(posLocation, 2, gl.FLOAT, false, 0, 0);

    gl.drawArrays(gl.LINES, 0, 2);
  }

  renderArrow(pos: {x: number, y: number}, angleRad: number, length: number, color: number[], opacity: number, camera: {x: number, y: number, scale: number}, zoomLevel: number) {
    const p2 = {
      x: pos.x + Math.cos(angleRad) * length,
      y: pos.y + Math.sin(angleRad) * length
    };
    this.renderLine(pos, p2, color, opacity, camera, zoomLevel);

    // Arrow head
    const headLen = length * 0.2;
    const a1 = angleRad + Math.PI * 0.85;
    const a2 = angleRad - Math.PI * 0.85;
    
    const h1 = {
      x: p2.x + Math.cos(a1) * headLen,
      y: p2.y + Math.sin(a1) * headLen
    };
    const h2 = {
      x: p2.x + Math.cos(a2) * headLen,
      y: p2.y + Math.sin(a2) * headLen
    };
    
    this.renderLine(p2, h1, color, opacity, camera, zoomLevel);
    this.renderLine(p2, h2, color, opacity, camera, zoomLevel);
  }
}
